import axios from '../utils/axios';

export default function checkSeekerExists(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/check-existence`, { params })
        .then(response => {
            return response.data.data.data.user_exists;
        })
        .catch(err => {
            return false;
        });
}